import { HTTP } from 'providers'
import { ProtocolsType } from 'types/Protocols.types'

export class ProtocolsService extends HTTP {
  private endpoint = '/certifications'
  private config: Record<string, any> = {
    showLoading: true
  }

  public fetchAll(params = {}) {
    return this.get({ endpoint: this.endpoint, params })
  }

  public fetchOne(id) {
    return this.get({
      endpoint: `${this.endpoint}/${id}`
    })
  }

  public async options() {
    return this.get({ endpoint: `${this.endpoint}/options` })
  }

  public async create(protocol: ProtocolsType) {
    return this.post({
      endpoint: this.endpoint,
      payload: protocol,
      config: this.config
    })
  }

  public async update(protocol: ProtocolsType) {
    return this.put({
      endpoint: `${this.endpoint}/${protocol.id}`,
      payload: protocol,
      config: this.config
    })
  }

  public async remove(id: string) {
    return this.delete({
      endpoint: `${this.endpoint}/${id}`
    })
  }
}
